const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	lista: [],
	listaVeiculoTipo: []
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case 'VEICULO_MODO_TELA':
			return {
				...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'VEICULO_LISTADO':
			return { ...state, lista: action.payload.data };

		case 'VEICULO_SET_AGUARDANDO':
			return {
				...state,
				aguardando: action.payload
			};
		
		case 'VEICULO_TIPO_SELECT_LISTADO':
			return {
				...state,
				listaVeiculoTipo: action.payload.data
			};

		default:
			return state;
	}
}
